export default __webpack_public_path__ + "static/media/export.04387ca0.svg";